<template>
  <div>
    <ValidationObserver ref="observer">
      <div style="position: relative; bottom: 2px">
        <v-container class="pt-5 px-5 pb-8">
          <div class="mb-3" style="font-weight: bold">
            Please complete your information
          </div>
          <div class="py-8">
            <div class="steplabel mb-2">
              Upload photo / อัปโหลดรูปถ่ายขนาด 1 นิ้ว
            </div>
            <ValidationProvider
              tag="div"
              :name="'รูปประจำตัว'"
              key="รูปประจำตัว"
              v-slot="{ errors }"
            >
              <upload-profile
                :errors="errors"
                v-model="input.profile_pic"
                :height="120"
              ></upload-profile>
            </ValidationProvider>
          </div>
          <div>
            <div class="steplabel">
              <span style="color: red">*</span>
              Title / คำนำหน้าชื่อ
            </div>
            <div>
              <ValidationProvider
                :name="'คำนำหน้าชื่อ'"
                :rules="'required'"
                key="คำนำหน้าชื่อ"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="input.title"
                  outlined
                  rounded
                  :items="['Mr. / นาย', 'Mrs. / นาง', 'Ms. / นางสาว']"
                  class="rounded-xl"
                ></v-select>
              </ValidationProvider>
            </div>
          </div>
          <div>
            <div class="steplabel">
              <span style="color: red">*</span>
              First name / ชื่อจริง
            </div>
            <div>
              <ValidationProvider
                :name="'First name / ชื่อจริง'"
                :rules="'required'"
                key="firstnameth"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  rounded
                  v-model="input.first_name"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>
          <div>
            <div class="steplabel">
              <span style="color: red">*</span>
              Last name / นามสกุล
            </div>
            <div>
              <ValidationProvider
                :name="'Last name / นามสกุล'"
                :rules="'required'"
                key="lastnameth"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  rounded
                  v-model="input.last_name"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>

          <div>
            <div class="steplabel">
              <span style="color: red">*</span>
              Mobile Phone / หมายเลขโทรศัพท์
            </div>
            <div>
              <ValidationProvider
                :name="'หมายเลขโทรศัพท์'"
                :rules="'required|numeric'"
                key="หมายเลขโทรศัพท์"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  rounded
                  :oninput="
                    10 !== undefined
                      ? `javascript: if (this.value.length > ${10}) this.value = this.value.slice(0, ${10});`
                      : ''
                  "
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  v-model="input.phone_number"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>
          <div>
            <div class="steplabel">
              <span style="color: red">*</span>
              E-mail Address / อีเมล
            </div>
            <div>
              <ValidationProvider
                :name="'อีเมล'"
                :rules="'required|email'"
                key="อีเมล"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  rounded
                  v-model="input.email"
                ></v-text-field>
              </ValidationProvider>
            </div>
          </div>

          <div>
            <div class="steplabel">
              <span style="color: red">*</span>
              Date of Birth / วันเดือนปีเกิด
            </div>
            <v-row dense>
              <v-col>
                <div>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <ValidationProvider
                        :name="'วันเดือนปีเกิด'"
                        :rules="'required'"
                        key="วันเดือนปีเกิด"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="input.dob"
                          outlined
                          rounded
                          :error-messages="errors"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      ref="picker"
                      v-model="input.dob"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="save"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col cols="auto">
                <div style="line-height: 38px" class="pl-5">
                  อายุ
                  <span
                    class="px-2"
                    style="color: rgb(10, 81, 136); font-size: 31px"
                    >{{ ageCal }}</span
                  >
                  ปี
                </div>
              </v-col>
            </v-row>
            <div class="nextbtn">
              <v-btn
                class="text-capitalize"
                block
                dark
                large
                rounded
                @click="next"
                color="#0a5188"
                >Next</v-btn
              >
            </div>
          </div>
        </v-container>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import UploadProfile from "@/components/UploadProfile.vue";
import moment from "moment";
export default {
  components: {
    UploadProfile,
  },
  data() {
    return {
      nationalities: ["ไทย", "อื่นๆ"],
      input: {
        profile_pic: "",
        title: "",
        othernationality: "",
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        nationality: "",
        dob: "",
      },
      menu: false,
    };
  },
  computed: {
    ageCal() {
      if (this.input.dob) {
        return moment().diff(this.input.dob, "years");
      } else return 0;
    },
  },
  methods: {
    async next() {
      var isValid = await this.$refs.observer.validate();

      if (isValid) {
        Object.assign(this.$store.state.profileinfo, this.input);
        if (this.input.nationality == "อื่นๆ") {
          this.$store.state.profileinfo.nationality = this.input.othernationality;
        }
        this.$store.state.step = 2;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  filters: {
    momentFormat: function(value) {
      return moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<style>
.nextbtn {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
.padform {
  background-color: white;
  height: 100%;
}
.steplabel {
  font-size: 14px;
  color: #8b8b8b;
}
.greyinput .v-input .v-input__control .v-input__slot {
  background-color: #f7f7f7 !important;
}
</style>
